import SaveButton from 'components/buttons/SaveButton';
import SelectInput from 'components/input-field/SelectInput';
import TextInput from 'components/input-field/TextInput'
import { Form, Formik } from 'formik';
import React, { Component } from 'react'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { Col, Row } from 'reactstrap';
import { DepartmentSchema } from './Validation';
import Loader from 'components/loader/Loader';
import { UpdateDepartmentRes, UpdateDepartmentTodo } from 'redux/slice/super-admin/master/department/UpdateDepartmen';

class UpdateDepartmentForm extends Component {
    constructor(props) {
        super(props);
        const department = this.props.location.state.state;
        this.state = {
            spiner: false,
            values: {
                id: department?.id || '',
                department: department?.name || '',
                status: department?.status || ''
            }
        };
    }

    status_option = [
        { "value": 'Active', "label": "Active" },
        { "value": 'Inactive', "label": "Inactive" }
    ]

    handleSubmit = (values) => {
        this.setState({ spiner: true });
        const { dispatch } = this.props;
        dispatch(UpdateDepartmentTodo(values)).then(() => this.add_res());

    }


    add_res = () => {
        if (UpdateDepartmentRes?.success) {
            toast.success(UpdateDepartmentRes?.message, { position: "bottom-right" });
            setTimeout(() => {
                this.props.history.push('/superadmin/department-list');
            }, 1500);
            this.setState({ spiner: false });
        } else {
            toast.error(UpdateDepartmentRes?.message, { position: "bottom-right" });
            this.setState({ spiner: false });
        }
    }
    render() {
        return (
            <>
                <div className='form_layout'>
                    {this.state.spiner ?
                        <div className='d-flex justify-content-center p-5'>
                            <Loader />
                        </div> :

                        <Formik
                            initialValues={this.state.values}
                            validationSchema={DepartmentSchema}
                            onSubmit={this.handleSubmit}
                        >
                            {({
                                values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
                                <Form>
                                    <Row>
                                        <Col xl='4'>
                                            <TextInput
                                                label_name='Department'
                                                placeholder=''
                                                name='department'
                                                value={values.department || ''}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.department && touched.department ? (<span className='text-danger form_label' >{errors.department}</span>) : null}
                                            />
                                        </Col>
                                        <Col xl='4'>
                                            <SelectInput
                                                closeMenu={true}
                                                label_name='Status'
                                                disabled={false}
                                                options={this.status_option}
                                                name='status'
                                                defaultValue={this.status_option?.find((option) => option.value === values.status)}
                                                onChange={(e) =>
                                                    setFieldValue('status', e.value)
                                                }
                                                onBlur={handleBlur}
                                                error={errors.status && touched.status ? (<span className='text-danger form_label' >{errors.status}</span>) : null} />
                                        </Col>
                                        <Col xl='12' className='d-flex justify-content-end'>
                                            <SaveButton name={'UPDATE'} />
                                        </Col>
                                    </Row>
                                </Form>
                            )}
                        </Formik>
                    }
                </div>
                <ToastContainer/>
            </>
        )
    }
}
export default connect()(withRouter(UpdateDepartmentForm));
